import { Link, LinkProps, styled } from '@mui/material'

type MolsonLinkProps = LinkProps & {
  to: string
  isActive: boolean
}

const DefaultLink = styled(Link)(({ theme }) => ({
  '&': {
    color: theme.palette.secondary[50],
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: '20px',
    padding: '8px 12px',
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    '&:hover': {
      color: theme.palette.secondary[500]
    }
  }
}))

const ActiveLink = styled(Link)(({ theme }) => ({
  '&': {
    color: theme.palette.secondary[900],
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: '20px',
    padding: '8px 12px',
    backgroundColor: theme.palette.primary.light,
    borderRadius: '8px',
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: theme.palette.primary.main
    }
  }
}))

export const MolsonLink = ({
  children,
  isActive,
  ...props
}: MolsonLinkProps) => {
  return isActive ? (
    <ActiveLink {...props}>{children}</ActiveLink>
  ) : (
    <DefaultLink {...props}>{children}</DefaultLink>
  )
}
